import { WhiteLabelPartners } from 'modules/2023-q4/white-label/consts/white-label-partners';
import { useStoreWhiteLabelPartner } from 'modules/2023-q4/white-label/stores/use-store-white-label-partner';

import { ProductAllocationProducts } from 'modules/2024-q1/allocation-by-amount-or-percentage/interface/product-allocation';
import { useFeatureFlags, FeatureFlags } from 'utils/feature-flags';

export const useHideProduct = () => {
  const { isFeatureFlagEnabled } = useFeatureFlags();
  const { partnerId } = useStoreWhiteLabelPartner((state) => state);

  const hideProduct = (product: string) => {
    if (
      isFeatureFlagEnabled(FeatureFlags.REACT_APP_2024_Q3_GRASSHOPPER_SUNSET) &&
      product === ProductAllocationProducts.TreasureCash
    ) {
      return true;
    }

    const partnerData = WhiteLabelPartners.find(
      (partner) => partner.id === partnerId,
    );

    const productsToHide = partnerData?.options?.hideProducts;

    return productsToHide?.[product] || false;
  };

  return { hideProduct };
};
